import { Box, Grid } from '@chakra-ui/react';
import { FC } from 'react';

import { MasterOutletFormInstance } from '../../types';
import { hasEquipment } from '../../utils/apply-helpers';
import { SectionCard } from './section-card';

type InfoFieldProps = {
  label: string;
  value?: string | number | null;
  colSpan?: number;
};

const InfoField: FC<InfoFieldProps> = ({ label, value, colSpan = 1 }) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="3px"
      border="1px solid #d7dce3"
      bg="#f7f8fa"
      borderRadius="8px"
      px={3}
      py={2}
      gridColumn={`span ${colSpan}`}
    >
      <Box as="span" fontSize="11px" color="#8a94a3" fontWeight={600}>
        {label}
      </Box>
      <Box as="span" fontSize="14px" color="#3a4150">
        {value}
      </Box>
    </Box>
  );
};

type OutletInfoSectionProps = {
  outlet: Partial<MasterOutletFormInstance>;
};

export const OutletInfoSection: FC<OutletInfoSectionProps> = ({ outlet }) => {
  const applicant = outlet.updater_user
    ? `${outlet.updater_user.full_name} (${outlet.updater_user.username})`
    : undefined;

  return (
    <SectionCard title="Торговая точка" badge="только для чтения">
      <Box px={6} pb={5}>
        <Grid templateColumns="repeat(4, 1fr)" gap={3}>
          <InfoField label="ID ТТ" value={outlet.id} />
          <InfoField label="Статус ТТ" value={outlet.status?.name} />
          <InfoField label="Заявитель" value={applicant} colSpan={2} />
          <InfoField label="Юридическое наименование" value={outlet.legal_name} colSpan={2} />
          <InfoField label="Наименование" value={outlet.name} colSpan={2} />
          <InfoField label="Вывеска" value={outlet.title} />
          <InfoField label="Маршрут" value={outlet.route_number?.name} />
          <InfoField label="Наличие оборудования" value={hasEquipment(outlet)} colSpan={2} />
          <InfoField label="Фактический адрес" value={outlet.address?.full_address} colSpan={4} />
        </Grid>
      </Box>
    </SectionCard>
  );
};
